import axiosInstance from 'services/axios/axios';

export const GetLDAP = async (uid) => {
	try {
		const url = 'api/IMSLDAPValidator/' + uid;
		const response = await axiosInstance.get(url);
		return response;
	} catch (ex) {
		console.error('Unable to fetch IMS information' + ex);
		return {
			data: [],
			error: 'Unable to fetch IMS information',
		};
	}
};